import 'regenerator-runtime/runtime';
import './externals';

import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { render } from 'react-dom';
import { ReduxBundlerProvider } from 'redux-bundler-hook';

import App from './app';
import getStore from './stores';
import { Reset } from './theme/reset';

const store = getStore();
const mountNode = document.getElementById('app');

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.LD_CLIENT_ID || '61eb45b65f6dd316cfa8a536',
  });
  render(
    <LDProvider>
      <ReduxBundlerProvider store={store}>
        <Reset />
        <App />
      </ReduxBundlerProvider>
    </LDProvider>,
    mountNode,
  );
})();
